<template>
  <div>

    <div class="row">
      <div class="col-6">
        <card card-body-classes="" no-footer-line>
          
          <h4 slot="header" class="title title-up">{{ (scope == 'edit') ? 'Update' : 'Create New' }} KJU Today</h4>

          <form>
            <div class="row">

              <div class="col-12">
                <!-- <label>Cover Image</label> -->
                <fg-input
                    type="text"
                    name="image"
                    label="Cover Image"
                    :rows="5"
                    v-validate="modelValidations.image"
                    :error="getError('image')"
                    v-model="model.image">
                <el-upload
                    class="avatar-uploader"
                    name="image"
                    accept="image/jpeg,image/png"
                    :data="{path: 'today/'}"
                    :action="uploadURL"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <!-- <img v-if="model.image" :src="model.image" class="avatar"> -->
                    <div v-if="model.image" class="avatar" :style="`background-image: url(${model.image})`"></div>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                </fg-input>
              </div>

              <div class="col-12">
                <fg-input
                    required
                    type="text"
                    name="title"
                    label="Title"
                    v-validate="modelValidations.title"
                    :error="getError('title')"
                    v-model="model.title">
                </fg-input>
              </div>

              <div class="col-12">
                <fg-input
                    required
                    type="text"
                    name="venue"
                    label="Venue"
                    v-validate="modelValidations.venue"
                    :error="getError('venue')"
                    v-model="model.venue">
                </fg-input>
              </div>

              <div class="col-12">
                <fg-input
                    required
                    type="text"
                    name="organised_by"
                    label="Organised By"
                    v-validate="modelValidations.organised_by"
                    :error="getError('organised_by')"
                    v-model="model.organised_by">
                </fg-input>
              </div>

              <div class="col-12">
                <fg-input
                  required
                  type="date"
                  name="date_time"
                  label="Date Time"
                  v-validate="modelValidations.date_time"
                  :error="getError('date_time')"
                  v-model="model.date_time">
                  <el-date-picker 
                      v-model="model.date_time" 
                      type="datetime" 
                      placeholder="Date Time">
                  </el-date-picker>
                </fg-input>
              </div>

              <div class="col-12 text-center">
                <n-button @click.native.prevent="resetForm" type="default">Reset</n-button>
                <n-button @click.native.prevent="addToList" type="primary">Add to List</n-button>
              </div>

            </div>
          </form>

        </card>
      </div>
      <div class="col-6">
        <card card-body-classes="" no-footer-line>
          <h4 slot="header" class="title title-up">KJU Today Preview</h4>

          <div class="row">
            <div class="col-12 mb-2">
              <fg-input
                required
                type="date"
                name="date"
                label="Date"
                :error="getError('date')"
                v-model="date">
                <el-date-picker 
                    v-model="date" 
                    type="date" 
                    format="M/d/yyyy"
                    value-format="M/d/yyyy"
                    placeholder="date">
                </el-date-picker>
              </fg-input>
            </div>

            <div class="col-6 mb-1" v-for="(item, index) in today" :key="index">
              <TodayCard 
                v-bind="item"
                @card-click="selectToday(item)"
              ></TodayCard>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <TodayCard :title="null" ></TodayCard>
            </div>
            <div class="col-12 text-center">
              <n-button @click.native.prevent="validate()" type="primary">{{ (scope == 'edit') ? 'Update' : 'Create' }} KJU Today</n-button>
            </div>
          </div>

        </card>
      </div>
    </div>

  </div>
</template>

<script>
  import { Card, Switch, TodayCard } from 'src/components';
  import { Select, Option, Tag, Upload, Drawer, DatePicker } from "element-ui";

  import { mapGetters } from 'vuex';

  export default {
    components: {
      Card,
      TodayCard,
      [Select.name]: Select,
      [Option.name]: Option,
      [Tag.name]: Tag,
      [Switch.name]: Switch,
      [Upload.name]: Upload,
      [Drawer.name]: Drawer,
      [DatePicker.name]: DatePicker,
    },
    computed: {
      ...mapGetters({
          authTokens: 'getAuthTokens',
          today: 'getToday'
      }),
      headers(){
          this.authTokens['content-type'] = 'multipart/form-data'
          let {token, refreshtoken} = this.authTokens
          return {token, refreshtoken};
      },
      uploadURL(){
          return `${process.env.VUE_APP_BASE_URL}/glimpses/upload`
      },
      scope(){
        return this.$route.path.includes('edit') ? 'edit' : 'add'
      }
    },
    data() {
      return {
          drawer: false,
          // scope: 'add',
          item: 'featured',
          searchQuery: null,
          date: null,
          model: {
              title: null,
              venue: null,
              oragnaised_by: null,
              image: null,
              date_time: null,
          },
          modelValidations: {
              title: {
                  required: true,
              },
              venue: {
                  required: true,
              },
              oragnised_by: {
                  required: true,
              },
              sent_time: {
                  required: true,
              }
          },
          filterMethod(query, item) {
              return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          }
      };
    },
    methods: {
      getError(fieldName) {
          return this.errors.first(fieldName);
      },
      addToList() {
          this.$validator.validateAll().then(isValid => {
              // this.$emit('on-submit', this.registerForm, isValid);

              if(isValid){
                  
                 this.today.push(Object.assign({},this.model));
                 this.model = {
                      title: null,
                      venue: null,
                      oragnaised_by: null,
                      image: null,
                      date_time: null,
                  }
                  this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
              }
          });
      },
      validate() {
          if(!this.date){
            this.$notify({
                message: `Choose a date for the notices to be created.`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'warning'
            })
            return ;
          }

          if(this.today.length <= 0){
            this.$notify({
                message: `Atleast one notice is requied`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'warning'
            })
            return ;
          }

          let payload = {
            date: this.date,
            today: this.today
          }
          switch(this.scope){
              case 'add'  : this.$store.dispatch('createToday', Object.assign({}, payload)); break;
              case 'edit' : this.$store.dispatch('updateToday', Object.assign({}, payload)); break;
          }
      },
      selectToday(today){
        this.model = Object.assign({}, today)
        this.removeToday(today)
      },
      resetForm(){
        this.model = {
            title: null,
            venue: null,
            oragnaised_by: null,
            image: null,
            date_time: null,
        }
      },
      removeToday(today){
        const index = this.today.indexOf(today);
        if (index > -1) {
          this.today.splice(index, 1);
        }
      },
      handlePreview(file) {
          this.model.image = URL.createObjectURL(file.raw);
      },
      handleAvatarSuccess(res, file) {
          this.model.image = res.data.image;
      },
      beforeAvatarUpload(file) {
          const isLt2M = file.size / 1024 / 1024 < 2;
          console.log(isLt2M);
          
          if (!isLt2M) {
              this.$notify({
                  message: `Cover picture size can not exceed 2MB!`,
                  icon: 'fa fa-bell',
                  horizontalAlign: 'right',
                  verticalAlign: 'top',
                  type: 'danger'
              })
          }
          return isLt2M;
      },
    },
    mounted() {

      if(this.scope == 'edit'){
        this.date = this.$route.params.date.split("-").join("/")
        this.$store.dispatch('getTodayByDate', {date: this.date})
      }
    }
  };
</script>

<style lang="scss">
.has-success.has-label:after, 
.has-danger.has-label:after {
    top: 43px;
}

.el-transfer-panel__filter.el-input{
  width: 85%;
}

.bootstrap-switch{
  display: block;
  width: 90px!important;
  height: 35px!important;

  &.bootstrap-switch-on{
      .bootstrap-switch-label{
          left: 70%;
      }
  }

  .bootstrap-switch-label{
      width: 35px!important;
      height: 35px!important;
  }

  .bootstrap-switch-handle-off,
  .bootstrap-switch-handle-on{
      font-weight: bold;
      line-height: 22px;
      text-indent: 10px;
      color: #273c75!important;
      width: 100%!important;
  }
  .bootstrap-switch-handle-off{
      text-indent: 15px;
  }
}

.ck-editor__editable {
  min-height: 300px;
  }

  .el-dialog__wrapper{
    position: fixed;
    height: 100vh;
    width: 50%;
    top: 0;
    right: 0px;
  }

  .news-drawer{
    .el-drawer__close-btn{
      outline: none;
    }

    .el-drawer__header{
      margin-bottom: 10px;
    }

    .el-drawer__body{
      padding: 5px 20px;

      label{
        display: none;
      }
    }

    .search-results{
      height: calc(100vh - 100px);
      overflow-y: auto;
    }
  }

</style>
